module.exports = __webpack_public_path__ + "img/energy2.0d4a60fd.png";